import { SupabaseClient } from '@supabase/supabase-js';

import { AuthService } from './authService';
import {
  NoOpSessionAdapter,
  SessionStorageAdapter,
} from './types/sessionAdapter';

// Export the AuthService class for platform-specific implementations
export { AuthService };

// Export session adapter types and implementations
export type { SessionStorageAdapter } from './types/sessionAdapter';
export { NoOpSessionAdapter } from './types/sessionAdapter';

/**
 * Factory function to create an AuthService instance
 * @param supabaseClient - Optional Supabase client instance
 * @param sessionAdapter - Optional session storage adapter for platform-specific implementations
 * @returns A new AuthService instance
 */
export function createAuthService(
  supabaseClient?: SupabaseClient,
  sessionAdapter?: SessionStorageAdapter
): AuthService {
  return new AuthService(supabaseClient, sessionAdapter);
}

/**
 * Default auth service instance for backward compatibility
 * @deprecated Use createAuthService() or dependency injection instead
 * This instance uses NoOpSessionAdapter and should be replaced with platform-specific setup
 */
export const authService = createAuthService(
  undefined,
  new NoOpSessionAdapter()
);
